import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from './useReducedMotion';

export const useScrollReveal = (threshold: number = 0.1) => {
  const ref = useRef<HTMLElement>(null);
  const reducedMotion = useReducedMotion();
  const [isVisible, setIsVisible] = useState(
    reducedMotion || typeof IntersectionObserver === 'undefined'
  );

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    if (reducedMotion || typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once revealed, stop observing
          observer.unobserve(element);
        }
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [reducedMotion, threshold]);

  return { ref, isVisible };
};
